import { currentTimeMillis, Module } from '@nu-art/ts-common';
import { ApiDef_Launch, Const_LaunchDeploy, UrlParam_EnvironmentId, UrlParam_FacilityId } from '../../knowledge-manager/managers/advisor-launch/shared.js';
import { apiWithBody, Thunder } from '@nu-art/thunderstorm-frontend/index';
export class ModuleFE_Launch_Class extends Module {
    _v1;
    constructor() {
        super();
        this._v1 = {
            getLaunchUrl: apiWithBody(ApiDef_Launch._v1.getLaunchUrl)
        };
    }
    getSmartOnFhirLaunchUrl = async (patientIdToLaunch, environmentId, facilityId) => {
        const launchUrlParams = {
            patientId: patientIdToLaunch,
            environmentId,
            facilityId,
            launchUrl: ''
        };
        // Call backend endpoint
        const smartOnFhirLaunchData = await this._v1.getLaunchUrl(launchUrlParams).executeSync();
        this.logInfo('Launch URL from backend:', smartOnFhirLaunchData.data.url);
        // Add timestamp for cache busting
        return `${smartOnFhirLaunchData.data.url}&updated=${currentTimeMillis()}`;
    };
    getDeployIntegrationLaunchUrl = async (environmentId, facilityId) => {
        if (!environmentId || !facilityId) {
            this.logError('Missing environment or facility id');
            throw new Error('Missing environment or facility id');
        }
        const env = Thunder.getInstance().getEnvironment().toLowerCase();
        const advisorUrl = this.config.advisorBaseUrl[env];
        if (!advisorUrl) {
            this.logError(`No advisor URL configured for environment: ${env}`);
            throw new Error(`No advisor URL configured for environment: ${env}`);
        }
        return `${advisorUrl}${Const_LaunchDeploy}?${UrlParam_EnvironmentId}=${environmentId}&${UrlParam_FacilityId}=${facilityId}`;
    };
}
export const ModuleFE_Launch = new ModuleFE_Launch_Class();
